import {
	IGetComboItemsShort,
	ICreateComboGroup,
	IUpdateComboGroup,
	IGetPaginatedComboGroups,
	IUpdateComboGroupPositions,
} from 'types';
import {
	serviceGetComboGroupInfo,
	serviceGetComboItemsShort,
	serviceCreateComboGroup,
	serviceUpdateComboGroup,
	serviceGetPaginatedComboGroups,
	serviceDeleteComboGroup,
	serviceGetComboGroupPositionList,
	serviceUpdateComboGroupPositions,
} from 'services/api/comboGroups';
import { createAppErrorMessage } from 'utils/helpers';

const getComboGroupInfo = async (comboGroupID: string) => {
	try {
		const response = await serviceGetComboGroupInfo(comboGroupID);
		return response;
	} catch (err) {
		const error = err as Error;
		const errorMessage = createAppErrorMessage(error, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getComboItemsShort = async (args: IGetComboItemsShort) => {
	try {
		const response = await serviceGetComboItemsShort(args);
		return response;
	} catch (err) {
		const error = err as Error;
		const errorMessage = createAppErrorMessage(error, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const createComboGroup = async (data: ICreateComboGroup) => {
	try {
		const response = await serviceCreateComboGroup(data);
		return response;
	} catch (err) {
		throw err;
	}
};

const updateComboGroup = async (data: IUpdateComboGroup) => {
	try {
		await serviceUpdateComboGroup(data);
	} catch (err) {
		throw err;
	}
};

const getPaginatedComboGroups = async (args: IGetPaginatedComboGroups) => {
	try {
		const response = await serviceGetPaginatedComboGroups(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteComboGroup = async (comboGroupID: string) => {
	try {
		await serviceDeleteComboGroup(comboGroupID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingComboGroup');
		throw new Error(errorMessage);
	}
};

const getComboGroupPositionList = async (dishId: string) => {
	try {
		const response = await serviceGetComboGroupPositionList(dishId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateComboGroupPositions = async (data: IUpdateComboGroupPositions) => {
	try {
		const response = await serviceUpdateComboGroupPositions(data);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingComboGroupPositions');
		throw new Error(errorMessage);
	}
};

export {
	getComboGroupInfo,
	getComboItemsShort,
	createComboGroup,
	updateComboGroup,
	getPaginatedComboGroups,
	deleteComboGroup,
	getComboGroupPositionList,
	updateComboGroupPositions,
};
